import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';
import { description, keyword } from 'src/app/SEO_Constant/seo';

@Component({
    selector: 'app-digital-visiting-card',
    templateUrl: './digital-visiting-card.component.html',
    styleUrls: ['./digital-visiting-card.component.css'],
    standalone: false
})
export class DigitalVisitingCardComponent implements OnInit {
  titles:any;
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: ' the best cost effective way to attract client`s attention.',
      },
      {
        title: 'Share Contact Information Quickly and Easily.',
      },
      {
        title: 'It`s Better for the Environment.',
      },
      {
        title: 'More Creative Leeway',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/Digital_Visiting.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }

  constructor( private title : Title, private router:Router, private meta: Meta ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
   }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) +' | Resiliencesoft')

         this.meta.removeTag('name=description');
            this.meta.removeTag('name=keywords');
            this.meta.addTags([
              {
                name: 'description',
                content: description.DigitalVisitingCard,
              },
              { name: 'keywords', content: capatelize(keyword.globle) + capatelize(keyword.DigitalVisitingCard) },
            ]);
  }

}
